import { FC, PropsWithChildren, createContext, useMemo } from 'react';

import { defaultFlags } from '@/providers/FeatureFlagsProvider/defaultFlags';
import { useFeatureFlagLocalOverrides } from '@/providers/FeatureFlagsProvider/hooks/useFeatureFlagLocalOverrides';
import { FeatureFlagMap } from '@/providers/FeatureFlagsProvider/type';

export const FeatureFlagContext = createContext<FeatureFlagMap>({});

export const FeatureFlagProvider: FC<PropsWithChildren> = ({ children }) => {
  const { overrides } = useFeatureFlagLocalOverrides();

  const flags = useMemo(() => ({ ...defaultFlags, ...overrides }), [overrides]);

  return (
    <FeatureFlagContext.Provider value={flags}>
      {children}
    </FeatureFlagContext.Provider>
  );
};
